import React, { useContext } from 'react';
import { NO_DATA_FOUND } from '../../../static/constants.js';
import { CostBenchmarkContext } from '../../../contexts/costBenchmarkingContext.js';
import { messageManager } from '../../System/messageManager/messageManager.js';
import GeneralEmptyState from '../../reusable/EmptyState/GeneralEmptyState/GeneralEmptyState.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';
import { useUser } from '../../../contexts/userContext.js';
import { NAVIGATION_PATHS } from '../../../static/navigationPaths.js';
import { useNavigate } from 'react-router';
import { buildPath } from '../../../services/navigateService.js';
import { generateEmptyStateText } from '../costBenchmarkHelpers.js';

const DefaultBenchmarkEmptyState = () => {
  const { budgetHasPrograms, populationBoundaries } = useContext(CostBenchmarkContext);
  const { nameConventions } = useNameConventions();
  const { user } = useUser();

  const navigate = useNavigate();

  const handleNavigate = () => {
    if (budgetHasPrograms) return;

    const path = buildPath(user, NAVIGATION_PATHS.PROGRAM_INVENTORY);

    navigate(path);
  };

  return (
    <GeneralEmptyState
      title={generateEmptyStateText(nameConventions, populationBoundaries?.population, budgetHasPrograms)}
      src={NO_DATA_FOUND.source}
      alt={NO_DATA_FOUND.alt}
      showButton={!budgetHasPrograms}
      buttonTitle={budgetHasPrograms ? '' : messageManager(nameConventions).COST_BENCHMARK.EMPTY_STATE.BUTTON}
      handleClick={handleNavigate}

    />
  );
};

export default DefaultBenchmarkEmptyState;
